import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Live state for one printer, sourced from zebraman via Redis pub/sub
 * and pushed to the frontend over the backend's Socket.IO connection.
 */
export interface PrinterState {
  sn: string;
  location: string | null;
  wifi_signal: number | null;
  queue_len: number;
  connected: boolean;
  scanner_connected: boolean | null;
  last_update: number | null;
}

interface PrinterSliceState {
  printers: PrinterState[];
}

const initialState: PrinterSliceState = {
  printers: [],
};

const printerSlice = createSlice({
  name: 'printer',
  initialState,
  reducers: {
    setPrinterStates(state, action: PayloadAction<PrinterState[]>) {
      state.printers = action.payload || [];
    },
  },
});

export const { setPrinterStates } = printerSlice.actions;
export default printerSlice.reducer;
